"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientLogger = void 0;
var HttpLogger_1 = require("./HttpLogger");
var LogLevel_1 = require("./LogLevel");
var StorageService_1 = require("./StorageService");
var ClientLogger = (function () {
    function ClientLogger(projectName, config) {
        this.storageService = StorageService_1.StorageService.instance();
        this.projectName = projectName;
        this.logLevel = (config === null || config === void 0 ? void 0 : config.logLevel) || LogLevel_1.LogLevel.Error;
        this.loggingEnabled =
            (config === null || config === void 0 ? void 0 : config.forceLogConsole) || this.storageService.getFeatureLoggingState();
        this.logAggregationEnabled =
            (config === null || config === void 0 ? void 0 : config.forceLogAggregation) ||
                this.storageService.getLogAggregationState();
    }
    ClientLogger.prototype.debug = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this.isDebugEnabled()) {
            console.log("[".concat(LogLevel_1.LogLevel.Debug, "]"), this.getPrefix(), message, data);
            if (this.logAggregationEnabled) {
                this.sendLog(message, data, LogLevel_1.LogLevel.Debug);
            }
        }
    };
    ClientLogger.prototype.info = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this.isInfoEnabled()) {
            console.log("[".concat(LogLevel_1.LogLevel.Info, "]"), this.getPrefix(), message, data);
            if (this.logAggregationEnabled) {
                this.sendLog(message, data, LogLevel_1.LogLevel.Info);
            }
        }
    };
    ClientLogger.prototype.warning = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this.isWarningEnabled()) {
            console.log("[".concat(LogLevel_1.LogLevel.Warning, "]"), this.getPrefix(), message, data);
            if (this.logAggregationEnabled) {
                this.sendLog(message, data, LogLevel_1.LogLevel.Warning);
            }
        }
    };
    ClientLogger.prototype.error = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this.isErrorEnabled()) {
            console.error("[".concat(LogLevel_1.LogLevel.Error, "]"), this.getPrefix(), message, data);
            if (this.logAggregationEnabled) {
                this.sendLog(message, data, LogLevel_1.LogLevel.Error);
            }
        }
    };
    ClientLogger.prototype.sendLog = function (message, data, logLevel) {
        if (this.loggingEnabled && this.logAggregationEnabled) {
            HttpLogger_1.HttpLogger.log(logLevel, message, data, this.projectName, this.getPrefix());
        }
    };
    ClientLogger.prototype.isDebugEnabled = function () {
        return this.loggingEnabled && this.logLevel === LogLevel_1.LogLevel.Debug;
    };
    ClientLogger.prototype.isInfoEnabled = function () {
        return (this.loggingEnabled &&
            [LogLevel_1.LogLevel.Debug, LogLevel_1.LogLevel.Info].includes(this.logLevel));
    };
    ClientLogger.prototype.isWarningEnabled = function () {
        return (this.loggingEnabled &&
            [LogLevel_1.LogLevel.Debug, LogLevel_1.LogLevel.Info, LogLevel_1.LogLevel.Warning].includes(this.logLevel));
    };
    ClientLogger.prototype.isErrorEnabled = function () {
        return (this.loggingEnabled &&
            [
                LogLevel_1.LogLevel.Debug,
                LogLevel_1.LogLevel.Info,
                LogLevel_1.LogLevel.Warning,
                LogLevel_1.LogLevel.Error,
            ].includes(this.logLevel));
    };
    ClientLogger.prototype.getPrefix = function () {
        return "[".concat(this.projectName, "]") + this.getClassPrefix();
    };
    ClientLogger.prototype.getClassPrefix = function () {
        var callFunction = "";
        var error = new Error();
        if (error.stack) {
            var stack = error.stack.replace("Error\n", "");
            var caller = stack.split("\n")[3];
            var isThisClass = caller.indexOf(this.constructor.name) < 0;
            if (isThisClass) {
                var callerClassName = caller.trim().split(" ")[1];
                if (callerClassName && callerClassName.length) {
                    callFunction = "[".concat(callerClassName, "]");
                }
            }
        }
        return callFunction;
    };
    return ClientLogger;
}());
exports.ClientLogger = ClientLogger;
